import { createWebStorageHook } from './create-web-storage-hook';

export const useSessionStorage = createWebStorageHook(
  globalThis.sessionStorage
);
export const useLocalStorage = createWebStorageHook(globalThis.localStorage);
